"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarePlan = void 0;
/**
 * Describes the intention of how one or more practitioners intend to deliver care for a particular patient, group or community for a period of time, possibly limited to care for a specific condition or set of conditions.
 */
var CarePlan = /** @class */ (function () {
    function CarePlan() {
    }
    return CarePlan;
}());
exports.CarePlan = CarePlan;
